// @flow
import { memo } from 'react'
import cx from 'classnames'

import css from './App.sass'

type Props = {
  className?: string,
  text: string,
  link: string,
  icon: string,
}

// eslint-disable-next-line prefer-arrow-callback
export const Application = memo<Props>(function Application(props: Props) {
  const { className, text, link, icon } = props

  return (
    <a target='_blank' rel='noopener noreferrer' href={link} className={cx(css.root, className)}>
      <div className={css.icon} style={{ backgroundImage: `url(${icon})` }} />
      <div className={css.text} dangerouslySetInnerHTML={{ __html: text }} />
    </a>
  )
})
